import { render, staticRenderFns } from "./PerformancePage.vue?vue&type=template&id=15095006&scoped=true"
import script from "./PerformancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformancePage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PerformancePage.vue?vue&type=style&index=0&id=15095006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15095006",
  null
  
)

export default component.exports